/* ── TG Category Grid — mobile scroll arrows ──────────────────
   Scrolls the panel row by one tile width per click and keeps
   arrow disabled state in sync with scroll position.
──────────────────────────────────────────────────────────────── */
(function () {
  function init(wrap) {
    var row = wrap.querySelector('[data-tg-cat-row]');
    var prevBtn = wrap.querySelector('[data-tg-cat-prev]');
    var nextBtn = wrap.querySelector('[data-tg-cat-next]');
    if (!row || !prevBtn || !nextBtn) return;

    function tileStep() {
      var panel = row.querySelector('.tcp-panel');
      return panel ? panel.getBoundingClientRect().width : row.clientWidth;
    }

    function updateDisabled() {
      var maxScroll = row.scrollWidth - row.clientWidth;
      prevBtn.disabled = row.scrollLeft <= 1;
      nextBtn.disabled = row.scrollLeft >= maxScroll - 1;
    }

    prevBtn.addEventListener('click', function () {
      row.scrollBy({ left: -tileStep(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      row.scrollBy({ left: tileStep(), behavior: 'smooth' });
    });

    row.addEventListener('scroll', updateDisabled, { passive: true });
    window.addEventListener('resize', updateDisabled);
    updateDisabled();
  }

  function initAll() {
    document.querySelectorAll('[data-tg-category-grid]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
